import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandPlan } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Data = BrandPlan[]

export const fetchBrandPlans = async ({ workspaceId, signal }: { workspaceId: number; signal?: AbortSignal }) => {
  const res = await sendToApi<{ brand_plans: BrandPlan[] }>(`/w/${workspaceId}/brand_plans`, { signal })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.brand_plans
}

export const useFetchAllBrandPlans = (options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(['workspaces', workspaceId, 'brandPlans'], () => fetchBrandPlans({ workspaceId }), {
    refetchOnWindowFocus: false,
    staleTime: (options?.cacheTime || 0) * 0.5,
    ...options,
  })
}
